module.exports = __webpack_public_path__ + "img/decotablePattyn.bfff7ab9.jpg";